import { render } from "./ExcelUpload.vue?vue&type=template&id=a6084e2a&scoped=true"
import script from "./ExcelUpload.vue?vue&type=script&lang=js"
export * from "./ExcelUpload.vue?vue&type=script&lang=js"

import "./ExcelUpload.vue?vue&type=style&index=0&id=a6084e2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6084e2a"]])

export default __exports__